export function KeenSliderKeyboardNavigation(slider) {
  function moveFlavourSlider(e, allSlides) {
    const { code, shiftKey } = e;
    let activeCan = slider.track.details.rel;
    const newSlider = slider.container.getAttribute("data-collection");
    const lastButtonInsideCard = e.target.dataset.action === "add-variant";
    const firstButtonInsideCard = e.target.hasAttribute("href");

    if (code === "Tab") {
      if (shiftKey && activeCan > 0) {
        if (newSlider && !firstButtonInsideCard) return;
        slider.prev();
      }
      if (!shiftKey && activeCan < allSlides.length - 1) {
        if (newSlider && !lastButtonInsideCard) return;
        if (newSlider) activeCan++;
        slider.next();
      }
      allSlides[activeCan].firstElementChild.focus();
    }
  }

  const initKeyboardNavigation = () => {
    Array.from(slider.container.children).forEach((slide, i, allSlides) => {
      slide.addEventListener("keydown", (e) => moveFlavourSlider(e, allSlides));
      return (e) => {
        slide.removeEventListener("keydown", moveFlavourSlider(e, allSlides));
      };
    });
  };

  slider.on("created", () => {
    initKeyboardNavigation();
  });
}
